module.exports = __webpack_public_path__ + "img/previous.4f553b61.svg";